

let connect = (a,b,ref,line,reverse=false) => {
  // ref = ref.normalize();
  let rotation = (75* ref.x - 37.5) * (reverse ? -1 : 1);
  let offset = 2 + ref.y*4;
  let refC = new Path({
    segments: [a,b]
  });
  refC.rotate(rotation,refC.getPointAt(0));
  let c = refC.getPointAt(refC.length/offset);
  let refD = new Path({
    segments: [b,a]
  });
  refD.rotate(rotation,refD.getPointAt(0));
  let d = refD.getPointAt(refD.length/offset);
  let cross = new Path({segments: [a,b]});
  let mid = cross.getPointAt(cross.length/2);
  
  line.add(a);
  line.curveTo(c,mid);
  line.curveTo(d,b);
  let pts = [a,b,c,d, mid];
  let names = ['a','b','c','d','mid'];
  if(false)
  pts.map((point,i) => {
    let text = new PointText({
      point: point- [20,20],
      content: names[i],
      fillColor: 'black',
      justification: 'center'
    });
    return text;
  });
  return line;
}

let size = 250+ Math.floor(Math.random()*400);
let pt = new Point(0.513, 0.4);
let colors = ["#DD2334","#CB9875","#0F8950","#63B3D3","#EEE7DA","#F8CE55","#878734","#BFACCC","#0F8950","#328AA5","#8ABDA2","#F37143","#D86DAA","#D67F63","#223767","#E459A0","#AD1F31","#80B5D4","#AB572D"];
let color1 = colors[Math.floor(Math.random()*colors.length)];
let color2 = colors[Math.floor(Math.random()*colors.length)];

function onMouseDown(e){
  color1 = colors[Math.floor(Math.random()*colors.length)];
  color2 = colors[Math.floor(Math.random()*colors.length)];
  size = 250+ Math.floor(Math.random()*400);
  draw();
}

function onMouseMove(e){
  let scaleX = .2+(e.point.x/view.bounds.width)*.7;
  let scaleY = .25+(e.point.y/view.bounds.height)*.65;
  pt = new Point(1-(scaleX),scaleY);
  draw();
}

const drawTwoByTwo = () => {
  project.activeLayer.clear();
  let unit = new Path.Rectangle(0,0,100,100);
  // unit.strokeColor = 'black';
  unit.fillColor = color1
  unit.position = view.bounds.center;

  let diagonal = new Path();
  // diagonal.strokeColor = 'black';
  diagonal.add(unit.bounds.bottomLeft);
  diagonal.add(unit.bounds.topRight);

  let topShape = new Path();
  // topShape.strokeColor = 'black';
  topShape.fillColor = color2;

  connect(unit.bounds.leftCenter,unit.bounds.topCenter,pt,topShape);
  connect(unit.bounds.topCenter,unit.bounds.center,pt,topShape);
  connect(unit.bounds.center,unit.bounds.leftCenter,pt,topShape);

  let bottomShape = topShape.clone();
  // bottomShape.fillColor = "blue";
  bottomShape.scale(-1,-1);
  bottomShape.bounds.bottomRight = unit.bounds.bottomRight;

  let tile = new Group({
    children: [unit,topShape,bottomShape,diagonal]
  });

  let units = Math.max(window.innerWidth,window.innerHeight) / size;
  let tiles = new Group();

  tile.scale(size/diagonal.bounds.width);
if(false)
  for (let i = 0; i < units; i++) {
    for (let j = 0; j < units; j++) {
      let tileClone = tile.clone();
      tileClone.position = new Point(i*size,j*size);
      tiles.addChild(tileClone);
    }
  }

  // tile.remove();
  tiles.bounds.topLeft = view.bounds.topLeft;
}




const draw = () => {
  project.activeLayer.clear();
  let unit = new Path.Rectangle(0,0,100,100);
  unit.fillColor = color1
  unit.position = view.bounds.center;
  //make a 2-d array of points representing a 3x3 grid in unit bounds
  let grid = [];
  for (let i = 0; i < 3; i++) {
    grid[i] = [];
    for (let j = 0; j < 3; j++) {
      grid[i][j] = new Point(unit.bounds.leftCenter.x + (unit.bounds.width/3)*i,unit.bounds.leftCenter.y + (unit.bounds.height/3)*j);
    }
  }

  let diagonal = new Path();
  diagonal.add(unit.bounds.bottomLeft);
  diagonal.add(unit.bounds.topRight);


    //draw path with one non-diag curve
  let oneCurve = new Path();
  oneCurve.fillColor = color2;

  connect(unit.bounds.topLeft,unit.bounds.topCenter,pt,oneCurve);
  oneCurve.add(unit.bounds.center);
  oneCurve.add(unit.bounds.topLeft);
  oneCurve.scale(1/1.5)

  //draw path with one non-diag curve
  let oneCurveD = new Path();
  oneCurveD.fillColor = color2;
  

  connect(unit.bounds.topLeft,unit.bounds.center,pt,oneCurveD);
  oneCurveD.add(unit.bounds.topCenter);
  oneCurveD.add(unit.bounds.topLeft);
  oneCurveD.scale(1/1.5)

  let twoCurve = new Path();
  connect(unit.bounds.topLeft,unit.bounds.center,pt,twoCurve);
  twoCurve.add(unit.bounds.topCenter);
  twoCurve.add(unit.bounds.topLeft);
  twoCurve.scale(1/1.5)

  let simple = new Path();
  simple.fillColor = color2;
  simple.add(unit.bounds.topCenter);
  simple.add(unit.bounds.topRight);
  simple.add(unit.bounds.rightCenter);
  simple.closed = true;
  simple.scale(1/1.5)

  let pointer = new Path();
  pointer.fillColor = color2;
  pointer.add(unit.bounds.bottomRight)
  connect(unit.bounds.center,unit.bounds.rightCenter,pt,pointer);
  connect(unit.bounds.rightCenter,unit.bounds.bottomRight,pt,pointer,true); 
  pointer.scale(1/1.5);

  let doubleCurve = new Path();
  doubleCurve.fillColor = color2;
  connect(unit.bounds.bottomRight,unit.bounds.center,pt,doubleCurve);
  connect(unit.bounds.center,unit.bounds.rightCenter,pt,doubleCurve);
  doubleCurve.scale(1/1.5);

  let doubleCurve2 = new Path();
  doubleCurve2.fillColor = color2;
  connect(unit.bounds.center,unit.bounds.topLeft,pt,doubleCurve2);
  connect(unit.bounds.topLeft,unit.bounds.topCenter,pt,doubleCurve2,true);
  doubleCurve2.scale(1/1.5);

  

  let tile = new Group({
    children: [unit,oneCurve,twoCurve,oneCurveD,diagonal,simple,pointer,doubleCurve,doubleCurve2]
  });

  let units = Math.max(window.innerWidth,window.innerHeight) / size;
  let tiles = new Group();

  tile.scale(size/diagonal.bounds.width);
  oneCurveD.bounds.center = unit.bounds.center;
  oneCurve.bounds.bottomRight = [unit.bounds.x+unit.bounds.width*(1/1.5),unit.bounds.height+unit.bounds.y];
  simple.bounds.topRight = unit.bounds.topRight
  let simpleCopy = simple.clone();
  simpleCopy.bounds.topCenter = unit.bounds.topCenter;
  let simpleCopy2 = simple.clone();
  simpleCopy2.bounds.rightCenter = unit.bounds.rightCenter;
  let oneCurveCopy = oneCurve.clone();
  oneCurveCopy.scale(-1,1);
  oneCurveCopy.rotate(90);
  oneCurveCopy.bounds.leftCenter = unit.bounds.leftCenter;
  pointer.bounds.bottomLeft = unit.bounds.bottomLeft;
  doubleCurve.bounds.bottomRight = unit.bounds.bottomRight;
  doubleCurve2.scale(-1,1);
  doubleCurve2.rotate(90)
  doubleCurve2.bounds.centerRight = simpleCopy2.bounds.left;
  let distance = new Point(unit.bounds.topLeft - doubleCurve2.segments[0].point);
  doubleCurve2.position += distance;

  for (let i = 0; i < units; i++) {
    for (let j = 0; j < units; j++) {
      let tileClone = tile.clone();
      tileClone.position = new Point(i*size,j*size);
      tiles.addChild(tileClone);
    }
  }

  // tile.remove();
  tiles.bounds.bottomRight = view.bounds.bottomRight;
  // tiles.scale(.2);
}

// drawTwoByTwo();

draw();